import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, CardImg, CardText, CardHeader } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Link } from "react-router-dom";

//Import Components
import MiniWidgets from "./MiniWidgets";
import RevenueAnalytics from "./RevenueAnalytics";
import TestimonyPercentage from "./TestimonyPercentage";
import EarningReports from "./EarningReports";
import { statsUrl, yearlyStatsUrl } from "../../helpers/url";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statsdata: [],
            yearlyStatsdata: [],
            breadcrumbItems : [
                { title : "UTJD", link : "#" },
                { title : "Dashboard", link : "#" },
            ],
            reports : [
                { icon : "ri-stack-line", title : "Strategic", value : "100", rate : "2.4%", desc : "Last Month" },
                { icon : "ri-store-2-line", title : "Camps", value : "32", rate : "2.4%", desc : "Last Month" },
                { icon : "ri-briefcase-4-line", title : "Prisons", value : "15", rate : "2.4%", desc : "Last Month" },
            ]
        }
    }

    componentDidMount() {
        this.getLatestStats();
        this.getYearlyStats();
    }

    getLatestStats() {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const jwt = JSON.parse(sessionStorage.getItem("authUser"));
        const accessToken = jwt.jwtToken;
        fetch(statsUrl, {
            method: "GET",
            headers: { "Content-Type": "application/json", "Authorization": accessToken }
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({
                    statsdata: data
                });
            })
            .catch(error => {
                this.setState({
                    error: true,
                    errorMessage: error,
                });
            });
    }

    getYearlyStats() {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const jwt = JSON.parse(sessionStorage.getItem("authUser"));
        const accessToken = jwt.jwtToken;
        fetch(yearlyStatsUrl, {
            method: "GET",
            headers: { "Content-Type": "application/json" , "Authorization": accessToken }
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({
                    yearlyStatsdata: data
                });
            })
            .catch(error => {
                this.setState({
                    error: true,
                    errorMessage: error,
                });
            });
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    {<Breadcrumbs title="Dashboard" breadcrumbItems={this.state.breadcrumbItems} />}
                        <Row>
                            <Col xl={4} xs={8}>
                                <Card>
                                    <CardImg top className="img-fluid" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-jVvsB97fjDTLTr8RB9vOMwxPCE9tb3dCaw&usqp=CAU" alt="Card cap"/>
                                    <div className="py-2 text-center">
                                        <Link to="/testimony" className="font-weight-medium">Register New Testimony</Link>
                                    </div>
                                </Card>
                            </Col>
                            <Col xl={4} xs={8}>
                                <Card>
                                    <CardImg top className="img-fluid" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-jVvsB97fjDTLTr8RB9vOMwxPCE9tb3dCaw&usqp=CAU" alt="Card image cap"/>
                                    <div className="py-2 text-center">
                                        <Link to="/testimonyManager" className="font-weight-medium">View Registered Testimonies</Link>
                                    </div>
                                </Card>
                            </Col>
                            
                            <Col lg={4}>
                                <Card outline color="primary" className="border">
                                    <CardHeader className="bg-transparent">
                                        <h5 className="my-0 text-primary"><i className="mdi mdi-bullseye-arrow mr-3"></i>Important Message</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <CardTitle className="mt-0">Maintance</CardTitle>
                                        <CardText>Maintance in our system therefor we ask all to report any issues experiences in the system to our developers.</CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col xl={8}>
                                <Row>
                                    <MiniWidgets statsdata={this.state.statsdata} />
                                </Row>
                                
                                {/* revenue Analytics */}
                                {this.state.yearlyStatsdata.length > 0 ?
                                <RevenueAnalytics statsdata={this.state.yearlyStatsdata} /> : ''}
                            </Col>

                            <Col xl={4}>

                                {/* sales Analytics */}  
                                <TestimonyPercentage statsdata={this.state.statsdata}/>

                                {/* earning reports */}
                                <EarningReports/>

                            </Col>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default Dashboard;
